import axios, { AxiosError, AxiosResponse } from "axios";
import { WarrantyActivationFormValues } from "../models/warranty";

const sleep = (delay: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(
  async (response) => {
    if (process.env.NODE_ENV === "development") await sleep(1000);
    return response;
  },
  (error: AxiosError) => {    
    return Promise.reject(error);
  }
);

const responseBody = <T>(response: AxiosResponse<T>) => response.data;

const requests = {
  get: <T>(url: string) => axios.get<T>(url).then(responseBody),
  post: <T>(url: string, body: {}) =>
    axios.post<T>(url, body).then(responseBody),
  put: <T>(url: string, body: {}) => axios.put<T>(url, body).then(responseBody),
  del: <T>(url: string) => axios.delete<T>(url).then(responseBody),
  patch: <T>(url: string, body: {}) => axios.patch<T>(url, body).then(responseBody),
};

const warranty = {
  lookUpWarranty: (warrantyNo: string, serialNo: string) =>
   requests.get<any>(`/Warranty/Lookup?warrantyNo=${warrantyNo}&serialNo=${serialNo}`),
  activation:(values: WarrantyActivationFormValues)=>
  requests.post<any>("/Warranty/CompleteWarrantyRegistration", values)
};
const agent = {
  warranty
};

export default agent;
